<section class="flex flex-col items-center gap-12 text-center" id="faq">
  <app-section-header [title]="'Frequently asked questions'">
    <p #description>
      Have questions about our pricing? We have answered the most common
      questions about billing, plans, and payments. If you need more help, don't
      hesitate to contact us by
      <a [href]="'mailto:' + emailSupport" target="_blank">Email</a> or via
      <a [href]="discordUrl" target="_blank">Discord</a>.
    </p>
  </app-section-header>
  <app-faq-accordion [items]="items" class="w-full lg:w-[1024px]" />
</section>
